<template>
  <div class="col-12">
    <div class="col-12" style="margin-top: 10px">
      <center><h3 style="color: black">Farmer Dashboard
         <b-button class="float-right" @click="handleback" variant="danger">
          <b-icon-arrow-left-circle-fill></b-icon-arrow-left-circle-fill> Back
      </b-button>
      </h3></center>
      <hr />
    </div>
    <div class="row">
      <div class="col-12">
        <b-card
          style="max-width: 30rem;background-color:#acf1ac;color:black;height:100px;"
          class="mb-2"
        >
          <b-card-text  @click="handleMy" style="margin-top:5%;">
          <center> <h4 class="animalKatta">My Animals - 4</h4></center>
          </b-card-text>
        </b-card>
      </div>
      <div class="col-12">
        <b-card
         
          style="max-width: 30rem;background-color:#8bdfdb;color:black;height:100px;"
          class="mb-2"
        >
          <b-card-text  @click="handleBuy" style="margin-top:5%;">
            <center><h4 class="animalKatta">Buy Animals - 10</h4></center>
          </b-card-text>
        </b-card>
      </div>
      <div class="col-12">
        <b-card
         
          style="max-width: 30rem;background-color:#9f8bdf;color:black;height:100px;"
          class="mb-2"
        >
          <b-card-text  @click="handleDoctor" style="margin-top:5%;">
            <center><h4>Near By Clinic - 4</h4></center>
          </b-card-text>
        </b-card>
      </div>
      <div class="col-12">
        <b-card
         
          style="max-width: 30rem;background-color:#9f8bdf;color:black;height:100px;"
          class="mb-2"
        >
          <b-card-text  @click="handleDoctor1" style="margin-top:5%;">
            <center><h4>Medical Certificate - 1</h4></center>
          </b-card-text>
        </b-card>
      </div>
      <div class="col-12">
        <b-card
         
          style="max-width: 30rem;background-color:#dfad52;color:black;height:100px;"
          class="mb-2"
        >
          <b-card-text  @click="handleCertificate" style="margin-top:5%;">
           <center><h4>Transport Certificate - 0</h4></center>
          </b-card-text>
        </b-card>
      </div>
      <div class="col-12">
        <b-card
        
          style="max-width: 30rem;background-color:#e99999;color:black;height:100px;"
          class="mb-2"
        >
          <b-card-text @click="handleProfile" style="margin-top:5%;">
           <center><h4>My Profile</h4></center>
          </b-card-text>
        </b-card>
      </div>
    </div>
    
  </div>
</template>
<script>
export default {
  data() {
    return {
      tabIndex: 0,
    };
  },
  methods: {
    handleback(){
      this.$router.go(-1);
    },
    view() {
      this.$router.push("/buyer");
    },
    add() {
      this.$router.push("/add_animal");
    },
    handleBuy() {
      this.$router.push("/buy_animals");
    },
     handleMy() {
      this.$router.push("/my_animals");
    },
    handleDetails() {
      this.$router.push("/cowdetails");
    },
    handleDoctor() {
      this.$router.push("/home/nearby_doctor");
    },
    handleDoctor1() {
      this.$router.push("/home/pending_req");
    },
    handleCertificate() {
      this.$router.push("home/View_Transport");
    },
    handleProfile() {
      this.$router.push("/farmer_profile");
    },
    oxDetails() {
      this.$router.push("/oxdetails");
    },
    goatDetails() {
      this.$router.push("/goatdetails");
    },
    buffeloDetails() {
      this.$router.push("/buffelodetails");
    },
    cowdetails() {
      this.$router.push("/Cowviewdetails");
    },
    Oxdetails() {
      this.$router.push("/Oxviewdetails");
    },
    Goatdetails() {
      this.$router.push("/Goatviewdetails");
    },
    Buffelodetails() {
      this.$router.push("/Buffeloviewdetails");
    },
  },
};
</script>
